'use client';
import React from 'react';
import { TypePlayKitPageTranslations } from '@/utils/translations/types/TypePlayKitPageTranslations';

import Heading, {
  HeadingTag,
  HeadingSize,
} from '@/components/ui/Heading/Heading';
import {
  generateBookAddonLink,
  getBookBundleUpsellProductDetails,
  TypeScheduledItemGroup,
} from '@/components/account/PlayKitSchedule/utils';
import { BookBundleUpsell } from '@/components/account/PlayKitSchedule/components';
import useLocale from '@/hooks/useLocale';
import interpolate from '@/utils/translations/interpolate';
import { formatMoney } from '@/utils/helpers';
import { PlayKitCard } from '@/components/account';

export interface UpcomingPlayKitProps {
  t: TypePlayKitPageTranslations;
  group: TypeScheduledItemGroup;
  isFirstGroup?: boolean;
}

function UpcomingPlayKit({ t, group, isFirstGroup }: UpcomingPlayKitProps) {
  const { shouldShowBookBundleUpsell, bookBundleUpsellProducts } =
    getBookBundleUpsellProductDetails(group);
  const locale = useLocale();

  return (
    <div data-testid="upcomingPlayKit">
      {isFirstGroup ? (
        <Heading
          tag={HeadingTag.H1}
          size={HeadingSize.H1}
          classes="pb-1 md:pb-2"
          text={t.upcomingPlayKits}
        />
      ) : null}

      {group.items.map((item, index) => {
        const isLastKitInGroup = index === group.items.length - 1;

        return (
          <div
            key={item.uuid}
            className="-translate-x-4 w-screen md:translate-x-0 md:w-full md:rounded-md p-6 md:p-8 mb-10 shadow-lg"
          >
            <PlayKitCard
              t={t}
              key={item.uuid}
              scheduledItem={item}
              isLastKitInGroup={isLastKitInGroup}
            >
              {isLastKitInGroup && shouldShowBookBundleUpsell && (
                <BookBundleUpsell
                  title={t.bookBundleAddOn}
                  linkHref={generateBookAddonLink(group, locale)}
                  linkCopy={interpolate(t.addBookBundles, {
                    bundleAmount: formatMoney(
                      bookBundleUpsellProducts[0].metadata.price_cents / 100,
                      locale,
                      true,
                    ),
                  })}
                  bookBundleUpsellProducts={bookBundleUpsellProducts}
                />
              )}
            </PlayKitCard>
          </div>
        );
      })}
    </div>
  );
}

export default UpcomingPlayKit;
